exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3TxXAi1XXxAEKvm7rCQpue{width:80vw;max-width:900px;margin-left:auto;margin-right:auto}@media screen and (max-width: 500px){._3TxXAi1XXxAEKvm7rCQpue{margin-left:20px;margin-right:20px;min-width:300px;width:auto}}._3Jh8WW02BZImRLf33RasX5{width:80vw;max-width:900px;margin-left:auto;margin-right:auto;max-width:750px}@media screen and (max-width: 500px){._3Jh8WW02BZImRLf33RasX5{margin-left:20px;margin-right:20px;min-width:300px;width:auto}}._2JJpOIvDopsUd8651LWOWT{width:100%;min-width:300px;margin:0 0}\n", ""]);

// Exports
exports.locals = {
	"normalBlock": "_3TxXAi1XXxAEKvm7rCQpue",
	"textBlock": "_3Jh8WW02BZImRLf33RasX5",
	"bigBlock": "_2JJpOIvDopsUd8651LWOWT"
};